<div class="container">
  <div class="row">
    <div class="col-md-12">
      <h1 class="mat-headline-medium" i18n>Sign Up</h1>
    </div>
  </div>
  <!-- <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="alert alert-danger" color="">
        Sign-up is currently set to invite-only at this stage of development.
        You will only be able to sign up if you have been invited and have a
        valid invite code.
      </div>
    </div>
  </div> -->
  <div class="row justify-content-center">
    <div class="col-md-12 text-center">
      <h3 class="mat-h2 text-center" i18n>Sign in instead?</h3>

      <div class="oauth-buttons d-flex flex-row justify-content-center">
        <button mat-flat-button color="accent" routerLink="/sign-in" i18n>
          Sign in
        </button>
        <button mat-flat-button color="warn">Google</button>
        <!-- <button mat-flat-button disabled color="accent">Twitter</button> -->
        <!-- <button mat-flat-button disabled color="primary">Github</button> -->
      </div>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-md-8">
      <h2 class="mat-h2 mt-5" i18n>Create a new account</h2>
      <form
        [formGroup]="createAccountForm!"
        class="d-flex flex-column"
        (ngSubmit)="tryCreateAccount(createAccountForm!.value)"
      >
        <mat-form-field appearance="outline">
          <mat-label i18n>Display Name</mat-label>
          <input matInput type="text" formControlName="displayName" required />
          <mat-hint i18n
            >Don't worry, the display name can be changed later.</mat-hint
          >
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label i18n>E-Mail address</mat-label>
          <input matInput type="email" formControlName="email" required />
          <mat-hint i18n
            >The e-mail address needs to be verified later.</mat-hint
          >
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label i18n>Password</mat-label>
          <input matInput type="password" formControlName="password" required />
          <mat-hint i18n>Choose a strong password.</mat-hint>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label i18n>Repeat Password</mat-label>
          <input
            matInput
            type="password"
            formControlName="repeatPassword"
            required
          />
          <mat-hint i18n
            >The repeated password needs to match the password
            entered.</mat-hint
          >
        </mat-form-field>

        <!-- Accept Terms and conditions -->
        <div class="mt-4 d-flex flex-row justify-content-left">
          <button
            mat-stroked-button
            routerLink="/terms-of-service"
            color="accent"
            i18n
          >
            Terms of Service
          </button>
          <button
            class="ml-3"
            mat-stroked-button
            routerLink="/privacy-policy"
            color="accent"
            i18n
          >
            Privacy policy
          </button>
        </div>

        <div class="mt-4 d-flex flex-row align-items-center">
          <mat-checkbox class="mr-3" formControlName="agreeCheck" required
            ><span class="mat-body" style="white-space: normal" i18n
              >I have read and understood the <b>Terms of Service</b> and the
              <b>Privacy Policy</b> and agree to both.</span
            >
          </mat-checkbox>
        </div>

        <div id="reCaptchaDiv" class="d-flex justify-content-center"></div>

        <div *ngIf="signUpError" class="mt-3 alert alert-danger">
          {{ signUpError }}
        </div>

        <div class="mt-5 mb-5 d-flex flex-row justify-content-center">
          <button
            mat-raised-button
            color="accent"
            type="submit"
            (click)="tryCreateAccount(createAccountForm!.value)"
            i18n
          >
            Create Account
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
